<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">

      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">Master SKU</h4>
                  <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                    style="margin-right: 5px" @click.prevent="createData()">
                    <i class="link-icon mdi mdi-plus"></i>
                    {{ $t("createNew") }}
                  </button>

                  <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px" @click.prevent="downloadData()">
                    <i class="link-icon mdi mdi-download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                  <button v-if="permision_role.method_upload" class="btn btn-dark float-end btn-xs"
                    style="margin-right: 5px" @click="massUploadMasterSKU()" type="button">
                    <i class="link-icon mdi mdi-upload"></i>
                    Upload Master SKU .xlsx
                  </button>

                </div>

                <div class="card-body">
                  <vue-good-table title="list-flux-master-sku" ref="list-flux-master-sku"
                    :select-options="{ enabled:false, selectOnCheckboxOnly: false, selectionText: $t('data_selected'), clearSelectionText: $t('clear'), }"
                    mode="remote" @on-selected-rows-change="selectionChanged" @on-page-change="onPageChange"
                    @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                    :isLoading.sync="isLoading" :pagination-options="{
                      enabled: true,
                      perPageDropdown: [10, 50, 100, 1000, 10000],
                      dropdownAllowAll: false,
                    }" :rows="rows" :columns="columns">

                    <!--<div slot="table-actions">
                      {{ $t("no_select_data") }}
                    </div>-->
                    <div slot="selected-row-actions">
                      <!-- <button v-if="permision_role.method_delete" class="btn btn-danger btn-xs" style="margin-right:20px;"
                        @click="deleteMass"> <i class="mdi mdi-send-outline"></i> {{ $t("DeleteTxt") }}</button> -->

                      <!-- <button class="btn btn-success btn-xs" @click="removeSku"><i class="mdi mdi-close"></i> {{
                          $t("cancel_order_txt")
                      }} </button> -->
                    </div>

                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                        <a href="#" v-if="permision_role.method_read" title="Detail" @click.prevent="
                          detailData(props.index, props.row)
                          ">
                          <i class="mdi mdi-eye" style="font-size:16px"></i>

                        </a>
                        <a href="#" v-if="permision_role.method_update" title="Edit"
                          @click.prevent="editData(props.index, props.row)">
                          <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>

                        </a>

                        <!-- <a href="#" v-if="permision_role.method_delete" title="Delete" @click.prevent="
                          deleteData(props.index, props.row)
                          ">
                          <i class="mdi mdi-trash-can-outline" style="font-size:16px; color:red"></i>
                        </a> -->
                      </span>

                      <span v-else-if="props.column.field == 'status'">
                        <span v-if="props.row.status == 'ACTIVE'" class="badge bg-info">
                          <h5>{{ props.row.status }}</h5>
                        </span>
                        <span v-else class="badge bg-secondary">
                          <h5>{{ props.row.status }}</h5>
                        </span>
                      </span>

                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::modal-->
        <modal name="massUploadMasterSKU" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
            role="dialog">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <form class="forms-sample" @submit.prevent="submitmassUploadMasterSKU" method="POST">
                  <div class="modal-header">
                    <h5 class="modal-title" id="massUploadMasterSKU">Master Upload SKU</h5>
                    <button type="button" class="btn-close" aria-label="btn-close"
                      @click.prevent="removeModals()"></button>
                  </div>
                  <div class="modal-body">
                    <div class="mb-3">
                      <label for="files" class="form-label">{{ this.$t("file") }}:</label>
                      <input type="file" class="form-control" readonly ref="filemassUploadMasterSKU"
                        @change="handleFilemassUploadMasterSKU($event)" required />

                      <div v-if="errors.file">
                        <div v-for="error in errors.file" :key="error" class="alert alert-primary"
                          role="alert">
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>

                    </div>
                    <div class="mb-3" v-show="detailUser?.role?.name == 'superadmin'">
                      <label for="company" class="form-label">Company:</label>
                      <v-select
                            :options="fetchCustomer"
                            v-model="selectedCustomer"
                            label="code"
                            return-object
                            @search="asyncCustomer"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.code }} | {{ option.name }}
                            </template>
                          </v-select>
                    </div>
                    <div class="mb-3">
                      <br>
                      <label for="downloadTemplateMasterSKU" class="form-label">
                        <a @click="downloadTemplateMasterSKU()" style="color: #6571ff;text-decoration: none;">
                          {{ this.$t("downloadTemplateMasterSKU") }}
                        </a>
                      </label>
                    </div>
                    <div class="mb-3" v-if="errorsDataMasterSKUUpload">
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <th>{{ $t('lineNo') }}</th>
                            <th>{{ $t('statusTxt') }}</th>
                            <th>{{ $t('messageTxt') }}</th>
                          </thead>
                          <tbody>
                            <tr v-for="(errorsDataMasterSKU, index) in errorsDataMasterSKUUpload" :key="index">
                              <th>{{ errorsDataMasterSKU.lineNo }}</th>
                              <th>{{ errorsDataMasterSKU.status }}</th>
                              <th>{{ errorsDataMasterSKU.message }}</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>


                    </div>
                  </div>
                  <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary"
                      @click.prevent="removeModals()">{{ this.$t("close_txt") }}</button>
                    <button type="submit" class="btn btn-primary" v-if="!errorsDataMasterSKUUpload">{{
                      this.$t("UploadTxt") }}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </modal>
        <!--end::modal-->









        <!--begin::modal-->
        <modal name="detailMasterSKU" :draggable="false" :scrollable="true" :height="'auto'">
          <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
            role="dialog">
            <div class="modal-dialog  modal-xl">
              <div class="modal-content">

                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Detail</h5>
                  <button type="button" class="btn btn-default"  @click.prevent="removeModalsdMasterSKU()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body">
                  <form class="forms-sample" @submit.prevent="submitData" method="POST">

                    <!-- <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('tarifMasterId')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          
                            <input
                            type="text"
                            class="form-control" readonly
                            id="tarifMasterId"
                            :placeholder="$t('tarifMasterId')"
                            v-model="forms.tarifMasterId"
                            required
                          />
  
  
  
                          <div v-if="errors.tarifMasterId">
                            <div
                              v-for="error in errors.tarifMasterId"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div> -->


                    <div class="row mb-2">
                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label">{{
                          $t('customerId')
                        }}</label>

                       
                        <!-- <input type="checkbox" disabled class="form-check-input" id="akitFlag" v-model="forms.customerId"> -->
                        <input type="text" class="form-control" readonly id="sku" placeholder="SKU" v-model="forms.customerId" required />

                        <div v-if="errors.customerId">
                          <div v-for="error in errors.customerId" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>



                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label">SKU</label>

                        <input type="text" class="form-control" readonly id="sku" placeholder="SKU" v-model="forms.sku" required />

                        <div v-if="errors.sku">
                          <div v-for="error in errors.sku" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>



                      <div class="col-lg-4">
                        <label for="defaultconfig" class="col-form-label">SKU Description(1)</label>

                        <input type="text" class="form-control" readonly id="skuDescr1" placeholder="SKU Description"
                          v-model="forms.skuDescr1" required />

                        <div v-if="errors.skuDescr1">
                          <div v-for="error in errors.skuDescr1" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>





                      <div class="col-lg-2">

                        <label for="defaultconfig" class="col-form-label"></label>

                        <div class="form-check mb-3">
                          <input type="checkbox" disabled class="form-check-input" id="activeFlag" v-model="activeFlag">
                          <label class="form-check-label" for="activeFlag">
                            Active Flag
                          </label>
                        </div>

                        <div v-if="errors.activeFlag">
                          <div v-for="error in errors.activeFlag" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>


                    </div>


                    <div class="row  mb-2">
                      <div class="col-lg-8">
                        <label for="defaultconfig" class="col-form-label">SKU Description(L)</label>

                        <input type="text" class="form-control" readonly id="skuDescr2" placeholder="SKU Description"
                          v-model="forms.skuDescr2" required />

                        <div v-if="errors.skuDescr2">
                          <div v-for="error in errors.skuDescr2" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>


                      <div class="col-lg-2">

                        <label for="defaultconfig" class="col-form-label"></label>

                        <div class="form-check mb-3">
                          <input type="checkbox" disabled class="form-check-input" id="akitFlag" v-model="kitFlag">
                          <label class="form-check-label" for="kitFlag">
                            Kit Flag
                          </label>
                        </div>

                        <div v-if="errors.kitFlag">
                          <div v-for="error in errors.kitFlag" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>


                      <div class="col-lg-2">

                        <label for="defaultconfig" class="col-form-label"></label>

                        <div class="form-check mb-3">
                          <input type="checkbox" disabled class="form-check-input" id="freePickGift" v-model="freePickGift">
                          <label class="form-check-label" for="freePickGift">
                            Free Pick Gift </label>
                        </div>

                        <div v-if="errors.freePickGift">
                          <div v-for="error in errors.freePickGift" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>

                    </div>

                    <div class="row mb-2">
                      <div class="col-lg-3">

                        <label for="defaultconfig" class="col-form-label">Gross Weight</label>

                        <!-- <money class="form-control" readonly placeholder="0.00000" v-model="forms.grossWeight" v-bind="digit">
                          
                        </money> -->
                        <input
                            type="number"
                            class="form-control" readonly
                            id="grossWeight"
                            
                            v-model="forms.grossWeight"
                            placeholder="0.00000"
                          />

                        <div v-if="errors.grossWeight">
                          <div v-for="error in errors.grossWeight" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>

                      <div class="col-lg-3">

                        <label for="defaultconfig" class="col-form-label">Net Weight</label>
                        <!-- <money class="form-control" readonly placeholder="0.00000" v-model="forms.netWeight" v-bind="digit"> -->
                        
                      
                        <input
                            type="number"
                            class="form-control" readonly
                            id="netWeight"
                            
                            v-model="forms.netWeight"
                            placeholder="0.00000"
                          />

                        <div v-if="errors.netWeight">
                          <div v-for="error in errors.netWeight" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>

                      </div>


                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label">Tare</label>
                        <!-- <money class="form-control" readonly placeholder="0.00000" v-model="forms.tare" v-bind="digit"></money> -->
                        <input type="number" class="form-control" readonly id="tare" v-model="forms.tare" placeholder="0.00000"/>
                        <div v-if="errors.tare">
                          <div v-for="error in errors.tare" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>





                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label">Price</label>
                        <!-- <money class="form-control" readonly placeholder="0.00000" v-model="forms.price" v-bind="digit"></money> -->
                        <input type="number" class="form-control" readonly id="price" v-model="forms.price" placeholder="0.00000"/>
                        <div v-if="errors.price">
                          <div v-for="error in errors.price" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>


                    </div>


                    <div class="row mb-3">

                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label">SKU Width</label>
                        <!-- <money class="form-control" readonly placeholder="0.00000" v-model="forms.skuWidth" 
                          v-bind="digit"></money> -->
                        <input type="number" class="form-control" readonly id="skuWidth" v-model="forms.skuWidth" placeholder="0.00000"/>
                        <div v-if="errors.skuWidth">
                          <div v-for="error in errors.skuWidth" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>


                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label">SKU Height</label>
                        <!-- <money class="form-control" readonly placeholder="0.00000" v-model="forms.skuHigh" 
                          v-bind="digit"></money> -->
                          <input type="number" class="form-control" readonly id="skuHigh" v-model="forms.skuHigh" placeholder="0.00000"/>
                        <!-- <input type="number" class="form-control" readonly id="skuWidth" v-model="forms.skuHigh" placeholder="0.00000"/> -->
                        <div v-if="errors.skuHigh">
                          <div v-for="error in errors.skuHigh" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>



                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label">SKU Length</label>
                        <!-- <money class="form-control" readonly placeholder="0.00000" v-model="forms.skuLength" 
                          v-bind="digit"></money> -->
                        <input type="text" class="form-control" readonly id="skuLength" v-model="forms.skuLength" placeholder="0.00000"/>
                        <div v-if="errors.skuLength">
                          <div v-for="error in errors.skuLength" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <label for="defaultconfig" class="col-form-label">Cube</label>
                        <!-- <money class="form-control" readonly placeholder="0.00000" v-model="forms.cube" v-bind="digit"></money> -->
                        <input type="number" class="form-control" readonly id="cube" v-model="forms.cube" placeholder="0.00000"/>
                        <div v-if="errors.cube">
                          <div v-for="error in errors.cube" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>






                    </div>

                    <div class="row mb-2">
                      <div class="card">
                        <div class="card-header">Shelf Life</div>

                        <div class="card-body">
                          <div class="row">

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Shelf Life</label>
                              <input type="number" class="form-control" readonly id="shelfLife" v-model="forms.shelfLife"
                                placeholder="0" />
                              <div v-if="errors.shelfLife">
                                <div v-for="error in errors.shelfLife" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Shelf Life Type</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.shelfLifeType"
                                placeholder=" " />
                              <div v-if="errors.shelfLifeUnit">
                                <div v-for="error in errors.shelfLifeUnit" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Shelf Life Unit</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.shelfLifeUnit"
                                placeholder=" " />
                              <div v-if="errors.shelfLifeUnit">
                                <div v-for="error in errors.shelfLifeUnit" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Shelf Life Alert Days</label>
                              <input type="number" class="form-control" readonly id="shelfLife" v-model="forms.shelfLifeAlertDays"
                                placeholder="0" />
                              <div v-if="errors.shelfLifeAlertDays">
                                <div v-for="error in errors.shelfLifeAlertDays" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Inbound Life Days</label>
                              <input type="number" class="form-control" readonly id="shelfLife" v-model="forms.inboundLifeDays"
                                placeholder="0" />
                              <div v-if="errors.inboundLifeDays">
                                <div v-for="error in errors.inboundLifeDays" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Outbond Life Days</label>
                              <input type="number" class="form-control" readonly id="shelfLife" v-model="forms.outboundLifeDays"
                                placeholder="0" />
                              <div v-if="errors.outboundLifeDays">
                                <div v-for="error in errors.outboundLifeDays" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label"></label>
                              <div class="form-check mb-3">
                                <input type="checkbox" disabled class="form-check-input" id="shelfLifeFlag"
                                  v-model="shelfLifeFlag">
                                <label class="form-check-label" for="freePickGift">
                                  Shelf Life Flag </label>
                              </div>

                              <div v-if="errors.shelfLifeFlagt">
                                <div v-for="error in errors.shelfLifeFlag" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2 ">
                      <div class="card">
                        <div class="card-header">Alternate SKU</div>

                        <div class="card-body">
                          <div class="row">
                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Alternate SKU 1</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.alternate_sku1"
                                placeholder="" />
                              <div v-if="errors.alternate_sku1">
                                <div v-for="error in errors.alternate_sku1" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Alternate SKU 2</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.alternate_sku2"
                                placeholder="" />
                              <div v-if="errors.alternate_sku2">
                                <div v-for="error in errors.alternate_sku2" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">Alternate SKU 3</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.alternate_sku3"
                                placeholder="" />
                              <div v-if="errors.alternate_sku3">
                                <div v-for="error in errors.alternate_sku3" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                            <div class="col-lg-3">
                              <label for="defaultconfig" class="col-form-label">Alternate SKU 4</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.alternate_sku4"
                                placeholder="" />
                              <div v-if="errors.alternate_sku4">
                                <div v-for="error in errors.alternate_sku4" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-3">
                              <label for="defaultconfig" class="col-form-label">Alternate SKU 5</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.alternate_sku5"
                                placeholder="" />
                              <div v-if="errors.alternate_sku5">
                                <div v-for="error in errors.alternate_sku5" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                          </div>




                        </div>
                      </div>
                    </div>



                    <div class="row mb-2">
                      <div class="card">
                        <div class="card-header">SKU Group</div>

                        <div class="card-body">
                          <div class="row">
                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 1</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.sku_group1"
                                placeholder="" />
                              <div v-if="errors.sku_group1">
                                <div v-for="error in errors.sku_group1" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 2</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.sku_group2"
                                placeholder="" />
                              <div v-if="errors.sku_group2">
                                <div v-for="error in errors.sku_group2" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 3</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.sku_group3"
                                placeholder="" />
                              <div v-if="errors.sku_group3">
                                <div v-for="error in errors.sku_group3" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 4</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.sku_group4"
                                placeholder="" />
                              <div v-if="errors.sku_group4">
                                <div v-for="error in errors.sku_group4" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 5</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.sku_group5"
                                placeholder="" />
                              <div v-if="errors.sku_group5">
                                <div v-for="error in errors.sku_group5" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 6</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.sku_group6"
                                placeholder="" />
                              <div v-if="errors.sku_group6">
                                <div v-for="error in errors.sku_group6" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>









                          </div>


                          <div class="row">


                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 7</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.sku_group7"
                                placeholder="" />
                              <div v-if="errors.sku_group7">
                                <div v-for="error in errors.sku_group7" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>


                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 8</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.sku_group8"
                                placeholder="" />
                              <div v-if="errors.sku_group8">
                                <div v-for="error in errors.sku_group8" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-2">
                              <label for="defaultconfig" class="col-form-label">SKU Group 9</label>
                              <input type="text" class="form-control" readonly id="shelfLife" v-model="forms.sku_group9"
                                placeholder="" />
                              <div v-if="errors.sku_group9">
                                <div v-for="error in errors.sku_group9" :key="error" class="alert alert-primary"
                                  role="alert">
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>



                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                        <div class="card">
                          <div class="card-header">Reserved Field</div>

                          <div class="card-body">
                              <div class="row">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 01</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField01" placeholder=""/>
                                        <div v-if="errors.reservedField01">
                                          <div
                                            v-for="error in errors.reservedField01"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 02</label>
                                  <input type="text" readonly class="form-control" id="udf02" v-model="forms.reservedField02" placeholder=""/>
                                        <div v-if="errors.udf02">
                                          <div
                                            v-for="error in errors.udf02"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 03</label>
                                  <input type="text" readonly class="form-control" id="udf03" v-model="forms.reservedField03" placeholder=""/>
                                        <div v-if="errors.reservedField03">
                                          <div
                                            v-for="error in errors.reservedField03"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 04</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField04" placeholder=""/>
                                        <div v-if="errors.reservedField04">
                                          <div
                                            v-for="error in errors.reservedField04"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 05</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField05" placeholder=""/>
                                        <div v-if="errors.reservedField05">
                                          <div
                                            v-for="error in errors.reservedField05"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 06</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField06" placeholder=""/>
                                        <div v-if="errors.reservedField06">
                                          <div
                                            v-for="error in errors.reservedField06"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                              </div>


                              <div class="row">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 07</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField07" placeholder=""/>
                                        <div v-if="errors.reservedField07">
                                          <div
                                            v-for="error in errors.reservedField07"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 08</label>
                                  <input type="text" readonly class="form-control" id="udf02" v-model="forms.reservedField08" placeholder=""/>
                                        <div v-if="errors.udf08">
                                          <div
                                            v-for="error in errors.udf08"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 09</label>
                                  <input type="text" readonly class="form-control" id="udf03" v-model="forms.reservedField09" placeholder=""/>
                                        <div v-if="errors.reservedField09">
                                          <div
                                            v-for="error in errors.reservedField09"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 10</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField10" placeholder=""/>
                                        <div v-if="errors.reservedField10">
                                          <div
                                            v-for="error in errors.reservedField10"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 11</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField11" placeholder=""/>
                                        <div v-if="errors.reservedField11">
                                          <div
                                            v-for="error in errors.reservedField12"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 12</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField12" placeholder=""/>
                                        <div v-if="errors.reservedField12">
                                          <div
                                            v-for="error in errors.reservedField12"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                              </div>


                              <div class="row">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 13</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField13" placeholder=""/>
                                        <div v-if="errors.reservedField13">
                                          <div
                                            v-for="error in errors.reservedField13"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 14</label>
                                  <input type="text" readonly class="form-control" id="udf14" v-model="forms.reservedField14" placeholder=""/>
                                        <div v-if="errors.udf14">
                                          <div
                                            v-for="error in errors.udf14"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 15</label>
                                  <input type="text" readonly class="form-control" id="udf03" v-model="forms.reservedField15" placeholder=""/>
                                        <div v-if="errors.reservedField15">
                                          <div
                                            v-for="error in errors.reservedField15"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 16</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField16" placeholder=""/>
                                        <div v-if="errors.reservedField16">
                                          <div
                                            v-for="error in errors.reservedField16"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 17</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField17" placeholder=""/>
                                        <div v-if="errors.reservedField17">
                                          <div
                                            v-for="error in errors.reservedField17"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 18</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField18" placeholder=""/>
                                        <div v-if="errors.reservedField18">
                                          <div
                                            v-for="error in errors.reservedField18"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                              </div>


                              <div class="row mb-2">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 19</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField19" placeholder=""/>
                                        <div v-if="errors.reservedField19">
                                          <div
                                            v-for="error in errors.reservedField19"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Reserved Field 20</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reservedField20" placeholder=""/>
                                        <div v-if="errors.reservedField20">
                                          <div
                                            v-for="error in errors.reservedField20"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                              </div>


                          </div>
                        </div>
                      </div>


                      <div class="row mb-2">
                        <div class="card">
                          <div class="card-header">User Define</div>

                          <div class="card-body">
                              <div class="row">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >UDF 1</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.udf01" placeholder=""/>
                                        <div v-if="errors.udf01">
                                          <div
                                            v-for="error in errors.udf01"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >UDF 2</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.udf02" placeholder=""/>
                                        <div v-if="errors.udf02">
                                          <div
                                            v-for="error in errors.udf02"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >UDF 3</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.udf03" placeholder=""/>
                                        <div v-if="errors.udf03">
                                          <div
                                            v-for="error in errors.udf03"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >UDF 4</label>
                                  <input type="text" readonly class="form-control" id="udf04" v-model="forms.udf04" placeholder=""/>
                                        <div v-if="errors.udf04">
                                          <div
                                            v-for="error in errors.udf04"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>



                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >UDF 5</label>
                                  <input type="text" readonly class="form-control" id="udf04" v-model="forms.udf05" placeholder=""/>
                                        <div v-if="errors.udf05">
                                          <div
                                            v-for="error in errors.udf05"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                               

                              
                              


                              

                             

                               

                                

                                



                              </div>


                            
                          </div>
                        </div>
                      </div>



                      <div class="row mb-2">
                        <div class="card">
                          <div class="card-header">Other</div>

                          <div class="card-body">
                              <div class="row">
                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Freight Class</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.freightClass" placeholder=""/>
                                        <div v-if="errors.freightClass">
                                          <div
                                            v-for="error in errors.freightClass"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Report Uom</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.reportUom" placeholder=""/>
                                        <div v-if="errors.reportUom">
                                          <div
                                            v-for="error in errors.reportUom"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-3">
                                  <label for="defaultconfig" class="col-form-label" >Default Shipment Uom</label>
                                  <input type="text" readonly class="form-control" id="udf01" v-model="forms.defaultShipmentUom" placeholder=""/>
                                        <div v-if="errors.defaultShipmentUom">
                                          <div
                                            v-for="error in errors.defaultShipmentUom"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>


                                <div class="col-lg-3">
                                  <label for="defaultconfig" class="col-form-label" >Default Receiving Uom</label>
                                  <input type="text" readonly class="form-control" id="defaultReceivingUom" v-model="forms.defaultReceivingUom" placeholder=""/>
                                        <div v-if="errors.defaultReceivingUom">
                                          <div
                                            v-for="error in errors.defaultReceivingUom"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>




                                <div class="col-lg-2">
                                  <label for="defaultconfig" class="col-form-label" >Pack Id</label>
                                  <input type="text" readonly class="form-control" id="udf04" v-model="forms.packId" placeholder=""/>
                                        <div v-if="errors.packId">
                                          <div
                                            v-for="error in errors.packId"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                          >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                          </div>
                                        </div>
                                </div>

                               

                              
                              


                              

                             

                               

                                

                                



                              </div>


                            
                          </div>
                        </div>
                      </div>

                    <div class="row mb-2">
                      <div class="col-lg-12">
                        <label for="defaultconfig" class="col-form-label">Note </label>
                        <textarea name="noteText" class="form-control" readonly v-model="forms.noteText"></textarea>
                        <div v-if="errors.noteText">
                          <div v-for="error in errors.noteText" :key="error" class="alert alert-primary" role="alert">
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>





                   
                  </form>
                </div>


                <div class="modal-footer justify-content-between">
                  <button type="button" class="btn btn-secondary" @click.prevent="removeModalsdMasterSKU()">{{this.$t("close_txt")}}</button>
                </div>


              </div>
            </div>
          </div>
        </modal>
        <!--end::modal-->


        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "CmlTarifIndex",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      digit: {
          decimal: ',',
          thousands: '.',
          prefix: ' ',
          suffix: '',
          precision: 5,
          masked: false
        },
      forms: {},
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      BAS_SKU_IDs: [],
      detailDivisi: [],
      totalRecords: 0,
      activeFlag : false,
      shelfLifeFlag : false,
      kitFlag : false,
      freePickGift : false,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: this.$t("customerId"),
          field: "customerId",
          thClass: 'text-center',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: this.$t("customerId"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: 'SKU',
          field: "sku",
          thClass: 'text-center',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'sku', // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: 'SKU Descr 1',
          field: "skuDescr1",
          thClass: 'text-center',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'skuDescr1', // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: 'SKU Descr 2',
          field: "skuDescr2",
          thClass: 'text-center',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'skuDescr1', // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: 'Active Flag',
          field: "activeFlag",
          width: "150px",
          thClass: 'text-center',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: '', // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['Y', 'N'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        

        {
          label: this.$t("action_txt"),
          field: "actions",
          thClass: 'text-center',
          sortable: false,
        },
      ],
      rows: [],
      rowsSelection: [],
      filemassUploadMasterSKU: '',
      errorsDataMasterSKUUpload: false,
      fetchCustomer: [],
      selectedCustomer: null,

    };
  },
  watch: {},
  methods: {
    loadCustomer() {
      const baseURI =
        this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },
    asyncCustomer(code) {
      this.fetchCustomer = [];
      const baseURI =
        this.$settings.endPointFluxOms +
        "v2/customer/get-data-company-oms?code=" +
        code;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }
        });
    },

    handleFilemassUploadMasterSKU(event) {
      this.filemassUploadMasterSKU = event.target.files[0];
    },

    massUploadMasterSKU() {
      this.$modal.show('massUploadMasterSKU')
      this.loadCustomer();
    },


    removeModalsdMasterSKU() {
      this.$modal.hide('detailMasterSKU')
    },

    removeModals() {
      this.$modal.hide('massUploadMasterSKU')
      this.filemassUploadMasterSKU = ""
      this.errorsDataMasterSKUUpload = false
      this.loadItems();

    },

    resetForm() {
      this.filemassUploadMasterSKU = ""
    },

    downloadTemplateMasterSKU() {
      //var params = this.$onBehind(this.$route.params.id);
      const baseURI = this.$settings.endPointFluxOms + "v2/sku/download-template-sku";
      var file_name = "flux-template-master-sku.xlsx";

      return this.$http
        .get(
            baseURI ,
          {
            responseType: "blob",
          }
        )
        .then((response) => {

          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    submitmassUploadMasterSKU() {
      this.isLoading = true;

      let formData = new FormData();
      formData.append("file", this.filemassUploadMasterSKU);
      formData.append("customer_id", this.selectedCustomer?.customer_id ? this.selectedCustomer.customer_id : "");

      const baseURI = this.$settings.endPointFluxOms + "v2/sku/upload";
      this.$http.post(baseURI, formData).then((response) => {
        this.isLoading = false;
        this.errorsDataMasterSKUUpload = response.data.datas;
        this.resetForm();
      }).catch((error) => {
        this.loading();


        if (error.code == "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));

        } else {

          if (error.response) {
            if (error.response.status === 422) {
              this.errorsDataMasterSKUUpload = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 401) {
              this.logout();
            } else if (error.response.status === 403) {
              this.$router.push("/authorized-error");
            } else if (error.response.status === 500) {
              this.$router.push('/server-error');
            } else {
              this.$router.push('/page-not-found');
            }
          }

        }
      });

    },


    selectionChanged(ev) {
      this.rowsSelection = [];
      this.BAS_SKU_IDs = [];
      this.rowsSelection = ev.selectedRows;

      this.rowsSelection.forEach((item) => {
        this.BAS_SKU_IDs.push(item.BAS_SKU_ID);

      });

    },

    deleteMass() {

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          //this.loadingSubmiting();
          this.loading();
          let data = {
            BAS_SKU_IDs: this.BAS_SKU_IDs
          }
          const baseURI =
            this.$settings.endPointFluxOms + "v2/sku/mass-delete";
          this.$http
            .post(baseURI, data)
            .then((response) => {
              //this.loading();
              this.success(response.data.datas.messages);
              this.idTarifMasterHeader = []
              this.loadItems();
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {

                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                  } else {
                    this.$router.push('/page-not-found');
                  }
                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });

    },

    removeSku() {
      this.idTarifMasterHeader = [];
      this.$refs['list-flux-master-sku'].unselectAllInternal()
    },

    downloadData() {
      const baseURI = this.$settings.endPointFluxOms + "v2/sku/index";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      return this.$http
        .get(
          baseURI +
          `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&customerId=${this.serverParams.columnFilters.customerId}&sku=${this.serverParams.columnFilters.sku}&activeFlag=${this.serverParams.columnFilters.activeFlag}&skuDescr1=${this.serverParams.columnFilters.skuDescr1}&skuDescr2=${this.serverParams.columnFilters.skuDescr2}&download=download`,

          {
            responseType: "blob",
          }
        )
        .then((response) => {

          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    createData() {
      window.location.href = "/flux-oms/master-sku/create";
    },


    editData(index, row) {
      var params = this.$onRandom(row.BAS_SKU_ID);
      window.location.href = "/flux-oms/master-sku/edit/" + params;
    },

    detailData(index, row) {
      this.forms = row;
      // this.forms.shelf_life_type_name = 
      this.activeFlag = this.forms.activeFlag == 'Y' ? true : false;
      this.shelfLifeFlag = this.forms.shelfLifeFlag == 'Y' ?  true : false;
      this.kitFlag = this.forms.kitFlag == 'Y' ? true: false;
      this.freePickGift = this.forms.freePickGift == 'Y' ? true: false;
      this.$modal.show('detailMasterSKU');
      // var params = this.$onRandom(row.idTarifMasterHeader);
      // window.location.href = "/flux-oms/master-sku/detail/" + params;
    },

    deleteData(index, row, status) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endPointFluxOms + "v2/sku/delete/" + row.BAS_SKU_ID;
          this.$http
            .delete(baseURI, formData, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {


                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));

                } else {

                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }

                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    // load items is what brings back the rows from server
    loadItems() {
      const baseURI = this.$settings.endPointFluxOms + "v2/sku/index";
      this.isLoading = true;

      return this.$http
        .get(
          baseURI +
          `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&customerId=${this.serverParams.columnFilters.customerId}&sku=${this.serverParams.columnFilters.sku}&activeFlag=${this.serverParams.columnFilters.activeFlag}&skuDescr1=${this.serverParams.columnFilters.skuDescr1}&skuDescr2=${this.serverParams.columnFilters.skuDescr2}`,
          { timeout: 120000 })
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        }).catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));

          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'SkuController') {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },


    logout() {

      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        console.log(response);

      });

      this.$logoutUser();
      window.location.href = '/';
    },
  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();
    this.loading();
  },
};
</script>
<style scoped>
.blur-content {
  filter: blur(5px);
}
</style>